"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitChoosable = exports.CHOOSABLE_UNITS = void 0;
exports.girthEditable = girthEditable;
exports.girthLabel = girthLabel;
exports.rateUnit = rateUnit;
// A surface's unit and girth as the measurer sees them. Every type's unit is
// fixed by hig_surfacetype except a free-measured type ("Other"), where the
// measurer picks m², LM or Each for a custom line (#417). The unit is a label
// to the maths, as in the template (no unit column): hours = quantity × coats
// ÷ rate + prep, litres = quantity × coats × girth ÷ spread, whatever it is.
// So an LM line's girth is its width, and an Each line's is the m² of one item.
const measure_ts_1 = require("./measure.js");
const surfaces_ts_1 = require("./surfaces.js");
/** The units a custom line can be measured in, in the order they are offered. */
exports.CHOOSABLE_UNITS = [surfaces_ts_1.SURFACE_UNIT.m2, surfaces_ts_1.SURFACE_UNIT.lm, surfaces_ts_1.SURFACE_UNIT.each];
/** The measurer picks the unit only on a free-measured type ("Other"); every other type's unit is its own. */
const unitChoosable = (type) => type?.method === measure_ts_1.METHOD.free;
exports.unitChoosable = unitChoosable;
/** Girth can be typed where the type allows it, or on a custom line measured in LM or Each. */
function girthEditable(surface, type) {
    if (type?.girthEditable)
        return true;
    return (0, exports.unitChoosable)(type) && surface.unit !== surfaces_ts_1.SURFACE_UNIT.m2;
}
/** What the girth box is called: the type's own label, else what girth means in the custom line's unit. */
function girthLabel(surface, type) {
    if (type?.girthEditable)
        return type.girthLabel ?? 'Girth';
    if (surface.unit === surfaces_ts_1.SURFACE_UNIT.each)
        return 'm² each';
    return 'Girth (m)';
}
/** A production or prep rate's unit: metres, square metres or items an hour. */
function rateUnit(unit) {
    if (unit === surfaces_ts_1.SURFACE_UNIT.lm)
        return 'm/h';
    if (unit === surfaces_ts_1.SURFACE_UNIT.each)
        return 'each/h';
    return 'm²/h';
}
